/* import __COLOCATED_TEMPLATE__ from './emergency-fields.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();